import { lazy } from 'react';

// Communications Migration (Migration & Data Export)
export const CommunicationsMigrationDashboard = lazy(() =>
  import('@/capabilities/communications-migration/pages/CommunicationsMigrationDashboard').then((m) => ({ default: m.CommunicationsMigrationDashboard }))
);

export const DataExportPage = lazy(() =>
  import('@/capabilities/communications-migration/pages/DataExportPage').then((m) => ({ default: m.DataExportPage }))
);

export const MigrationHistoryPage = lazy(() =>
  import('@/capabilities/communications-migration/pages/MigrationHistoryPage').then((m) => ({ default: m.MigrationHistoryPage }))
);

export const MigrationAssessment = lazy(() =>
  import('@/capabilities/communications-migration/pages/MigrationAssessment').then((m) => ({ default: m.MigrationAssessment }))
);

export const VoicemailDashboard = lazy(() =>
  import('@/capabilities/communications-migration/pages/VoicemailDashboard').then((m) => ({ default: m.VoicemailDashboard }))
);
